module.exports = __webpack_public_path__ + "img/icone-costs.f79faaab.svg";